import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-currency-input',
  standalone: false,
  templateUrl: './currency-input.component.html',
  styleUrl: './currency-input.component.css',
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ] 
})
export class CurrencyInputComponent {
  @Input() name: string = '';
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() value: number = 0;
  
  @Output() emitResult = new EventEmitter<Number>();
  
  constructor() { 
  }

  public currencyInputChanged(value: string) {
    var num = value.toString().replace(/[$,]/g, "");
    this.emitResult.emit(Number(num));
  }
}
